import { render, staticRenderFns } from "./Filiation.vue?vue&type=template&id=1511de4d&scoped=true"
import script from "./Filiation.vue?vue&type=script&lang=js"
export * from "./Filiation.vue?vue&type=script&lang=js"
import style0 from "./Filiation.vue?vue&type=style&index=0&id=1511de4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511de4d",
  null
  
)

export default component.exports